import { useState, useEffect } from "react";

import { monthNumberToName, dayNumberToName } from "../utils/utils";

import moment from "moment";
import SlotEventCard from "./SlotEventCard";

export default ({ selectedDate, numDay, events, onClickEvent }) => {
  const [day, setDay] = useState(null);
  const [slotEvents, setSlotEvents] = useState([]);

  const buildDay = () => {
    const date = moment(selectedDate);
    date.startOf("isoWeek");
    date.add(numDay - 1, "days");
    setDay(date);

    const evs = events.filter((ev) => {
      return (
        ev.visible &&
        ev.date === date.format("YYYY-MM-DD") &&
        ev.timeStart === -1
      );
    });
    setSlotEvents(evs);
  };

  useEffect(() => {
    buildDay();
  }, [events]);

  return (
    <div
      className={`calendar-calendar-horas-menu-dia ${day && day.format("YYYY-MM-DD") === moment().format("YYYY-MM-DD") ? "calendar-week-day-today" : ""}`}
    >
      {day && (
        <div
          className="text-dias-semanas"
          style={{
            color:
              day && day.format("YYYY-MM-DD") === moment().format("YYYY-MM-DD")
                ? "var(--dark-blue)"
                : "#4a4a4a",
          }}
        >
          {dayNumberToName(day.format("E"), true).slice(0, 3)}
        </div>
      )}
      {day && (
        <div
          className={`text-dias-semanas-dia
            ${
              day && day.format("YYYY-MM-DD") === moment().format("YYYY-MM-DD")
                ? "hoy"
                : ""
            }
          `}
        >
          <span>{day.format("DD")}</span>
          <span className="month">
            {monthNumberToName(day.format("MM"), true).slice(0, 3)}
          </span>
        </div>
      )}
      <div className="calendar-event-slot clickable-slot title-slot calendar-day-events-week">
        {slotEvents.map((event, index) => {
          return (
            <SlotEventCard
              key={index}
              event={event}
              numEvents={slotEvents.length}
              numEvent={index}
              onClickEvent={() => onClickEvent(event)}
            />
          );
        })}
      </div>
    </div>
  );
};
